import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography, Badge, Skeleton, IconButton } from '@mui/material';
import { FiX } from 'react-icons/fi';
import Policy from 'components/policies/Policy';
import axios from 'lib/axios';

const ViewPolicyModal = ({ policyId, setOpenViewModal }) => {
    const [reactions, setReactions] = useState([]);
    const [policy, setPolicy] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const fetchPolicy = async () => {
        setIsLoading(true);
        try {
            const res = await axios.get(`/policies/policy/${policyId}/0`);

            if (res.data.success) {
                setIsLoading(false);
                setPolicy(res.data.policy);
            }
        } catch (error) {
            setIsLoading(false);
            console.log(error);
        }
    };
    async function fetchReacts() {
        axios.get('/reacts').then(({ data }) => {
            if (data.success) {
                setReactions(data.reacts);
            }
        });
    }
    useEffect(() => {
        fetchPolicy();
        fetchReacts();
    }, []);

    const handleOutsideClick = (e) => {
        if (e.target === e.currentTarget) {
            setOpenViewModal(false);
        }
    };

    return (
        <Box display="flex" alignItems="center" justifyContent="center" sx={{ height: '100vh' }} onClick={handleOutsideClick}>
            <Box
                sx={{ width: { lg: '50vw', md: '90vw', xs: '90vw' }, position: 'relative', mx: 2, borderRadius: '10px' }}
                onClick={(e) => e.stopPropagation()}
            >
                <IconButton
                    onClick={() => setOpenViewModal(false)}
                    sx={{
                        position: 'absolute',
                        right: -16,
                        top: -16,
                        color: 'text.secondary',
                        bgcolor: 'grey.100',
                        borderRadius: '50%',
                        '&:hover': { bgcolor: 'grey.300' },
                        zIndex: 2
                    }}
                    size="small"
                >
                    <FiX size={17} />
                </IconButton>
                <Box mt={2} sx={{ height: '50vh', overflowY: 'scroll' }}>
                    {isLoading ? (
                        <Card sx={{ p: 2 }}>
                            <Skeleton variant="circular" width={40} height={40} />

                            <Skeleton width={`100%`} height={50} />
                            <Skeleton width={`100%`} height={50} />
                            <Skeleton width={`100%`} height={50} />
                        </Card>
                    ) : (
                        <>{policy.policy_id && <Policy policy={policy} setPolicies={() => {}} reacts={reactions} formSidebar={true} />}</>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default ViewPolicyModal;
